import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import L1MenuItemsQuery from '@atlassian/jira-relay/src/__generated__/L1MenuItemsQuery.graphql';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';

/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import { getProjectKey } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';

export const nav4SidebarContentCoreEntryPoint = createEntryPoint({
	// sidebar is critical to rendering the initial view of a page
	root: JSResourceForUserVisible(
		() =>
			import(/* webpackChunkName: "nav4-sidebar-content-core-entry-point" */ './src/index').then(
				({ SidebarContentForEntryPoint }) => SidebarContentForEntryPoint,
			),
		{ includeInShellOnlySsrBundle: true, entryFsSsrLiftImportToModule: true },
	),
	// Result matches the generics of the async component's EntryPointProps
	// except for TComponentProps which is derived from `root`
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	getPreloadProps(params: EntryPointRouteParams & any) {
		const {
			context,
			tenantContext,
			entryPoints = {},
			isAppsExpanded,
			isFiltersExpanded,
			isPlansExpanded,
			isProjectsExpanded,
			isOperationsExpanded,
			isOverviewsExpanded,
		} = params;
		// The two parameters have been injected by the theme setter, and should
		// not be here. Setting them naively just to be able to use the sidebar entryPoint again.
		const projectAri = '';
		let projectKey = '';
		if (context.match.params?.projectKey) {
			projectKey = context.match.params.projectKey;
		} else if (context.match.params?.issueKey && fg('move-issue-view-to-entrypoint')) {
			projectKey = getProjectKey(context.match, context.query);
		}

		return {
			// Queries your async component uses
			queries: {
				nav4SidebarContentCore: {
					// generated .graphql
					parameters: L1MenuItemsQuery,
					// variables for your query
					variables: {
						cloudId: tenantContext.cloudId,
						isAppsExpanded,
						isFiltersExpanded,
						isPlansExpanded,
						isProjectsExpanded,
						isOperationsExpanded,
						isOverviewsExpanded,
						projectAri,
						projectKey,
						entityAriProjects: `ari:cloud:jira:${tenantContext.cloudId}:navigation-settings/activation/${tenantContext.activationId}/projects`,
						ownerAri:
							tenantContext.atlassianAccountId &&
							`ari:cloud:identity::user/${tenantContext.atlassianAccountId}`,
						isAnonymous: tenantContext.isAnonymous,
					},
					// fetch options
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
				},
			},
			entryPoints,
		};
	},
});
